// extracted by mini-css-extract-plugin
export default {"flex":"Popover_flex__jEz8-","spread":"Popover_spread__hawAw","label":"Popover_label__SdiAQ"};